import Modal from 'react-bootstrap/Modal';
import { connect } from "react-redux";
import {setShowShareSequenceModal} from 'actions/index.js';
import { Button } from 'reactstrap';
import React, { Component } from 'react';
import { Badge} from 'reactstrap';
import Dropdown from 'react-dropdown'

class ShareSequenceModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            usersInGuilds: [],
            usersToShare: [],
        }

        this.getMembers();
    }

    async getMembers() {
    }

    executeShare() {
        for (let i in this.state.usersToShare) {
            let userId = this.state.usersToShare[i].userId;
            let sequence = this.props.sequence;
            // todo: better error message
            this.props.ethereum.crypto
                .shareSequence(sequence, userId)
                .catch(err =>
                       window.alert("User has no public key, so we can't share with them. Try asking them to set a password"));
        }
        
        this.clear();
        this.hide();
    }

    clear() {
        this.setState({
            usersToShare: [],
        });
    }

    onSelectUser(user) {
        this.setState({usersToShare: this.state.usersToShare.concat([user])});
    }

    getUserOptions() {
        let options = [];
        for (let i in this.state.usersInGuilds) {
            let user = this.state.usersInGuilds[i];
            options.push({label: user.userName, value: user});
        }

        return options;
    }

    removeUser(user) {
        let i = this.state.usersToShare.indexOf(user);
        this.state.usersToShare.splice(i, 1);
        this.setState(this.state.usersToShare);
    }

    onClickNo() {
        this.clear();
        this.hide();
    }

    hide() {
        this.props.setShowShareSequenceModal(undefined);
    }

    render() {
        let name = this.props.sequence === undefined ? "" : this.props.sequence.name;
        return (
            <Modal dialogClassName="preset-modal" show={this.props.show} onHide={() => this.hide()}>
              <Modal.Header closeButton>
                <Modal.Title>Share "{name}"</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Dropdown
                  className=''
                  options={this.getUserOptions()}
                  onChange={(o) => this.onSelectUser(o.value)}
                  value={undefined}
                  placeholder="Choose users to share with" />
                  
                  {this.state.usersToShare.map(user => <Badge onClick={() => this.removeUser(user)}>{user.userName}</Badge>)}
            </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => this.executeShare()}>
                Yes
            </Button>
                <Button variant="primary" onClick={() => this.onClickNo()}>
                No
            </Button>
                </Modal.Footer>
                </Modal>
        );
   }
}
const mapDispatchToProps = dispatch => {
    return {
        setShowShareSequenceModal: (show) => dispatch(setShowShareSequenceModal(show)),
    };
};

export default connect(null, mapDispatchToProps)(ShareSequenceModal);

